export default {
  // Μόδος
  "common.mode.auto": "Αυτόματο λειτουργία χρήσης ανανεώσιμων ενεργειών",
  "common.mode.economy": "Οικονομικός τρόπος",
  "common.mode.exigency": "Λειτουργία έκτακτης ανάγκης",

  // Συσκευές
  "common.grid": "Δίκτυο ηλεκτρικής ενέργειας",
  "common.evChargers": "Σταθμοί φορτίσματος ηλεκτρικών οχημάτων (πολλαπλοί)",
  "common.evCharger": "Σταθμός φορτίσματος ηλεκτρικού οχήματος",
  "common.pv": "Ηλιακή ενέργεια (PV)",
  "common.inverter": "Μετατροπέας (συσκευή μετατροπής ηλεκτρικής ενέργειας)",
  "common.pcs": "Μετατροπέας + μπαταρία",
  "common.terminal": "Τερματική συσκευή",
  "common.airc": "Κλιματισμός (AC)",
  "common.engine": "Κινητήρας",
  "common.battery": "Μπαταρία",
  "common.metter": "Εлектρολόγιο",
  "common.other": "Άλλα",
  "common.power": "Ισχύς",
  "common.powerTotal": "Συνολική ισχύς",
  "common.voltage": "Τάση",
  "common.electricity": "Ηλεκτρική ενέργεια",
  "common.current": "Ρεύμα",
  "common.homeUsage": "Συνολική φορτίωση οικίας",
  "common.battery.power": "Ισχύς μπαταρίας",

  // Δεδομένα
  "common.noDataAvailable": "Δεν υπάρχουν διαθέσιμα δεδομένα αυτή τη στιγμή~",
  "common.tips": "Συμβουλές",
  "common.reset": "Επαναφορά (καθαρισμός)",
  "common.currencyUnit": "¥ ( Γιουαν)",
  "common.submiting": "Υποβολή... Παρακαλώ περιμένετε...",
  "common.close": "Κλείσιμο",
  "common.from": "Από",
  "common.useIn": "Για",
  "common.energyPercent": "Ποσοστό ροής ενέργειας",
  "common.dataFlow": "Ροή δεδομένων",
  "common.getDataIng": "Λήψη δεδομένων... Παρακαλώ περιμένετε...",
  "common.pageLoading": "Φόρτωση σελίδας... Παρακαλώ περιμένετε...",
  "common.reseting": "Επαναφορά σελίδας... Παρακαλώ περιμένετε...",
  "common.save": "Αποθήκευση",
  "common.onlyNumberTips": "Μπορούν να εισαχθούν μόνο αριθμοί",
  "common.offline": "Αποσυνδεδεμένο (δεν είναι συνδεδεμένο στο Διαδίκτυο)",
  "common.online": "Συνδεδεμένο (συνδεδεμένο στο Διαδίκτυο)",
  "common.fault": "Σφάλμα (προβλημα)",
  "common.charge": "Φόρτιση (μπαταρίας)",
  "common.discharge": "Αποφόρτιση (χρήση ενέργειας μπαταρίας)",
  "common.buy": "Αγορά",
  "common.sell": "Πώληση",
  "common.loadingInfo": "Φόρτωση... Παρακαλώ περιμένετε...",

  // Γενικές λειτουργίες
  "common.moreFeatures": "Περισσότερες λειτουργίες",
  "common.confirm": "Επιβεβαίωση",
  "common.saveing": "Αποθήκευση... Παρακαλώ περιμένετε...",
  "common.searchPlacholder": "Εισάγετε λέξη-κλειδί για αναζήτηση",
  "common.iSee": "Καταλαβαίνω",
  "common.pageErrorTips1": "Ωχ, παρουσιάστηκε σφάλμα στη σελίδα~",
  "common.pageErrorTips2": "Επαναφόρτωση σελίδας ή επικοινωνία με υποστήριξη~",
  "common.refresh": "Επαναφόρτωση",
  "common.backToHome": "Επιστροφή στην αρχική σελίδα",
  "common.checkTips": "Έλεγχος... Παρακαλώ περιμένετε...",
  "common.back": "Επιστροφή",
  "common.cancel": "Ακύρωση (διαγραφή)",
  "common.optional": "Προαιρετικό (δεν είναι υποχρεωτικό)",
  "common.required": "Υποχρεωτικό να συμπληρωθεί",
  "common.status": "Κατάσταση",
  "common.statusNoDelete": "Δεν διαγράφηκε",
  "common.statusDelete": "Διαγράφηκε",
  "common.submit": "Υποβολή",
  "common.disable": "Απενεργοποίηση",
  "common.enable": "Ενεργοποίηση",
  "common.year": "Έτος",
  "common.month": "Μήνας",
  "common.day": "Ημέρα",
  "common.version": "Έκδοση:",
  "common.backHome": "Επιστροφή στην αρχική σελίδα",
  "common.backHomeSorry": "Συγνώμη, η σελίδα έχει γίνει άκυρη",
  "common.requestTips1": "Η διαδικασία λήψης δεδομένων βρίσκεται σε εξέλιξη, μην υποβάλλετε ξανά",
  "common.requestTips2": "Ειδοποίηση συστήματος",
  "common.requestTips3": "Η сеància εισόδου έχει λήξει, παρακαλώ συνδεθείτε ξανά",
  "common.requestTips4": "Εισαγωγή ξανά",
  "common.requestTips5": "Η εισαγωγή δεν είναι έγκυρη ή η сеància έχει λήξει, παρακαλώ συνδεθείτε ξανά.",
  "common.requestTips6": "Εσφαλμός διακομιστή, παρακαλώ δοκιμάστε αργότερα.",
  "common.requestTips7": "Το αίτημα συστήματος έχει λήξει το χρονικό όριο",
  "common.requestTips8": "Διεπαφή συστήματος",
  "common.requestTips9": "Σφάλμα",
  "common.iknow": "Καταλαβαίνω",
  "common.logoutSuccess": "Επιτυχής αποσύνδεση",
  
  // Στοιχεία περισσότερων πληροφοριών
  "common.knowMore.title": "Για περισσότερες πληροφορίες, επικοινωνήστε με την Beineng",
  "common.knowMore.email": "Email για επικοινωνία",
  "common.knowMore.phone": "Τηλέφωνο για επικοινωνία",
  "common.knowMore.wechat": "WeChat για επικοινωνία",
  "common.knowMore.website": "Επίσημη διεύθυνση ιστοσελίδας",
  "common.knowMore.address": "Διεύθυνση για επικοινωνία",
  "common.knowMore.addressDetail": "Μονάδα 1205, 1301, Κτίριο 5, Οδός Qingxi 8, Δήμος Huaning, Πόλη Nanjing, Περιφέρεια Jiangsu",
  
  // Τοπική σύνδεση
  "common.localConnection": "Τοπική σύνδεση",
  "common.operateInApp": "Εκτελέστε λειτουργίες μέσα στην εφαρμογή!",
  
  "common.enbleStaus": "Κατάσταση ενεργοποίησης",
  "common.battery.status": "Δεν φορτίζεται, δεν χρησιμοποιείται",

  // Σχετικά με τον λογαριασμό
  "account.forgetThePassword": "Ξέχασα τον κωδικό πρόσβασης",
  "account.logInDirectly": "Άμεση εισαγωγή",
  "account.tips1": "Μεταφορά στη σελίδα... Παρακαλώ περιμένετε...",
  "account.tips2": "Πρώτα, διαβάστε και αποδεχτείτε τους όρους χρήσης!",
  "account.autoLogin": "Αυτόματη εισαγωγή",
  "account.userLogin": "Εισαγωγή χρήστη",
  "account.registerTips": "Δεν έχετε λογαριασμό? Κάντε κλικ εδώ για εγγραφή",
  "account.userEmail": "Όνομα χρήστη / Email",
  "account.userEmailTips": "Εισάγετε όνομα χρήστη ή email",
  "account.password": "Κωδικός πρόσβασης",
  "account.passwordTips": "Εισάγετε τον κωδικό πρόσβασης",
  "account.submit": "Υποβολή",
  "account.submitTips": "Υποβολή... Παρακαλώ περιμένετε...",
  "account.otherLoginTips": "Ή επιλέξτε άλλη μέθοδο εισόδου",
  "account.userRegistration": "Εγγραφή χρήστη",
  "account.userName": "Όνομα χρήστη",
  "account.userNameTips": "Εισάγετε όνομα χρήστη",
  "account.emailTips1": "Εισάγετε διεύθυνση email",
  "account.emailTips2": "Μη έγκυρη μορφή email",
  "account.phone": "Τηλέφωνο",
  "account.phoneTips1": "Εισάγετε αριθμό τηλεφώνου",
  "account.phoneTips2": "Μη έγκυρος αριθμός τηλεφώνου",
  "account.phoneTips3": "Εισάγετε αριθμό τηλεφώνου",
  "account.passwordTips1": "Εισάγετε κωδικό πρόσβασης (6-30 χαρακτήρες)",
  "account.passwordTips2": "Μη έγκυρη μορφή κωδικού πρόσβασης: Ο κωδικός πρόσβασης πρέπει να περιέχει αγγλικά γράμματα, αριθμούς, κάτω παύλα (_), παύλα (-) και τελεία (.), μήκος 6-12 χαρακτήρων",
  "account.passwordTips3": "Οι δύο κωδικοί πρόσβασης που εισάχθηκαν δεν είναι ίδιοι, παρακαλώ ελέγξτε και εισάγετε ξανά!",
  "account.passwordTips4": "Εισάγετε κωδικό πρόσβασης: Ο κωδικός πρόσβασης πρέπει να περιέχει αγγλικά γράμματα, αριθμούς, κάτω παύλα (_), παύλα (-) και τελεία (.)",
  "account.passwordTips5": "Επιβεβαίωση κωδικού πρόσβασης",
  "account.passwordTips6": "Εισάγετε για να επιβεβαιώσετε τον κωδικό πρόσβασης",
  "account.passwordTips7": "Οι δύο κωδικοί πρόσβασης που εισάχθηκαν δεν είναι ίδιοι, παρακαλώ ελέγξτε και εισάγετε ξανά!",
  "account.passwordTips8": "Εισάγετε για να επιβεβαιώσετε τον κωδικό πρόσβασης",
  "account.passwordTips9": "Συγχαρητήρια, η εγγραφή ήταν επιτυχής!",
  "account.passwordTips10": "Το όνομα χρήστη σας είναι:",
  "account.emailIs": "Το email σας είναι:",
  "account.goToLoginPage": "Θα μεταφερθείτε αυτόματα στη σελίδα εισόδου σε s δευτερόλεπτα",
  "account.goLogin": "Εισαγωγή",
  "account.goRegister": "Εγγραφή",
  "account.loginSuccess": "Επιτυχής εισαγωγή",
  "account.email": "Email",
  "account.sologn": "Δημιουργούμε μια ολοκληρωμένη πλατφόρμα ενέργειας ειδικά σχεδιασμένη για εσάς",
  "account.pleaseAgree": "Έχω διαβάσει και συμφωνώ με",
  "userAgreement.privacyPolicy": "Πολιτική απορρήτου",

  // Σχετικά με τον κωδικό επαλήθευσης
  "account.code": "Κωδικός επαλήθευσης",
  "account.codeTips": "Εισάγετε τον κωδικό επαλήθευσης",
  "account.codeTips2": "Μη έγκυρος κωδικός επαλήθευσης",

    "account.inviteCodeTips": "Παρακαλώ εισάγετε τον κωδικό πρόσκλησης",
    "account.inviteCodeHint": "Παρακαλώ επικοινωνήστε με τον εγκαταστάτη ή το προσωπικό συντήρησης για να λάβετε τον κωδικό πρόσκλησης",
  // Τροποποίηση και επαναφορά κωδικού πρόσβασης
  "account.modifyPasswordByAccount": "Τροποποίηση κωδικού πρόσβασης μέσω λογαριασμού",
  "account.modifyPasswordByEmail": "Τροποποίηση κωδικού πρόσβασης μέσω email",
  "account.getPasswordByAccount": "Λήψη κωδικού πρόσβασης μέσω λογαριασμού",
  "account.getPasswordByEmail": "Λήψη κωδικού πρόσβασης μέσω email",

  "account.sendEmailTips": "Ο κωδικός επαλήθευσης έχει σταλεί στο email, παρακαλώ ελέγξτε",
  "account.name": "Όνομα λογαριασμού",
  "account.newPassword": "Νέος κωδικός πρόσβασης",
  "account.confirmNewPassword": "Επιβεβαίωση νέου κωδικού πρόσβασης",
  "account.nameTips": "Εισάγετε όνομα λογαριασμού",
  "account.passwordModifySuccess": "Η τροποποίηση του κωδικού πρόσβασης ήταν επιτυχής",
  "account.emailCode": "Κωδικός επαλήθευσης email",
  "account.emailCodeTips": "Εισάγετε τον κωδικό επαλήθευσης email",
  "account.emailCodeTips2": "Μη έγκυρος κωδικός επαλήθευσης email",
  "account.emailModifySuccess": "Η τροποποίηση του κωδικού πρόσβασης ήταν επιτυχής",
  "account.passworTips1": "Ο κωδικός πρόσβασης σας έχει επαναφερθεί!",
  "account.passwordTips11": "Εισάγετε για να επιβεβαιώσετε τον κωδικό πρόσβασης",
  "account.passwordTips12": "Εισάγετε νέο κωδικό πρόσβασης",
  "account.nickname": "Ψευδώνυμο",
  "account.modifyNickname": "Τροποποίηση ψευδώνυμου",
  "account.modifyNicknameSuccess": "Η τροποποίηση του ψευδώνυμου ήταν επιτυχής!",
  "account.nicknameTips": "Εισάγετε ψευδώνυμο",
  "account.nicknameError": "Η τροποποίηση του ψευδώνυμου απέτυχε!",

  // Γρήγορη εγγραφή και εισαγωγή
  "account.login": "Εισαγωγή",
  "account.quickRegister": "Γρήγορη εγγραφή",
  "account.sendCode": "Στείλε κώδικα",
  "account.sendTips": "Μπορεί να σταλεί ξανά σε s δευτερόλεπτα",
  "account.sendEmailIng": "Αποστολή email... Παρακαλώ περιμένετε...",
  "account.emailNotEmpty": "Το πεδίο email δεν μπορεί να είναι κενό",
  "account.registerAccount": "Εγγραφή λογαριασμού",
  "account.registerWelcome": "Καλώς ήρθατε στην εγγραφή SusprSafe",
  "account.usernameLimit": "Το όνομα χρήστη πρέπει να ξεκινά με γράμμα, μπορεί να περιέχει μόνο γράμματα, αριθμούς και κάτω παύλα (_), μήκος 5-15 χαρακτήρων",

  // Πληροφορίες πνευματικών δικαιωμάτων
  "copyright.desc2": "Πληροφορίες εγγραφής ιστοσελίδας: Αριθμός εγγραφής ICP Περιφέρειας Jiangsu 2021169764",

  // Επεξεργασία πληροφοριών χρήστη
  "editUserInfo.editUserInformation": "Επεξεργασία πληροφοριών χρήστη",
  "editUserInfo.modifyUsername": "Τροποποίηση ονόματος χρήστη",
  "editUserInfo.changePictures": "Αλλαγή εικόνας προφίλ",
  "editUserInfo.savePicturesSuccess": "Η αποθήκευση της εικόνας προφίλ ήταν επιτυχής",
  "editUserInfo.saveError": "Η αποθήκευση απέτυχε",
  "editUserInfo.pictureLimit": "Το μέγεθος της εικόνας δεν μπορεί να υπερβαίνει 2 MB",
  "editUserInfo.uploadPicture": "Ανέβασμα εικόνας προφίλ",
  "editUserInfo.picturePreview": "Προεπισκόπηση",
  
  "editUserInfo.bindPhoneNumber": "Σύνδεση αριθμού τηλεφώνου",
  "editUserInfo.bindEmail": "Σύνδεση email",
  "editUserInfo.changePassword": "Αλλαγή κωδικού πρόσβασης",

  "editUserInfo.notificationSettings": "Ρυθμίσεις ειδοποιήσεων",
  "editUserInfo.editAccount": "Επεξεργασία πληροφοριών λογαριασμού",
  "editUserInfo.waitBingting": "Σύνδεση... Παρακαλώ περιμένετε...",
  "editUserInfo.collapse": "Σύμπτυξη (διαχωρισμός)",
  "editUserInfo.modifyBinding": "Τροποποίηση σύνδεσης",
  
  "editUserInfo.emailAddress": "Διεύθυνση email",
  "editUserInfo.tips1": "Η σύνδεση email ήταν επιτυχής",
  "editUserInfo.tips2": "Η αποθήκευση απέτυχε",
  "editUserInfo.tips3": "Αποστολή κωδικού επαλήθευσης email... Παρακαλώ περιμένετε...",
  "editUserInfo.tips4": "Ο κωδικός επαλήθευσης έχει σταλεί στο email xxxx, παρακαλώ ελέγξτε",
  "editUserInfo.tips5": "Η αποστολή του κωδικού επαλήθευσης απέτυχε!",
  "editUserInfo.tips6": "Ο αριθμός τηλεφώνου έχει συνδεθεί",
  "editUserInfo.tips7": "Το email έχει συνδεθεί",
  "editUserInfo.emailTips1": "Εισάγετε διεύθυνση email",
  "editUserInfo.emailTips2": "Μη έγκυρη μορφή email",
  "editUserInfo.emailTips3": "Μπορεί να σταλεί ξανά σε xxxx δευτερόλεπτα",
  "editUserInfo.emailTips4": "Στείλε κώδικα",
  "editUserInfo.emailTips5": "Το πεδίο κωδικού επαλήθευσης email δεν μπορεί να είναι κενό",
  "editUserInfo.emailTips6": "Μη έγκυρος κωδικός επαλήθευσης email",
  "editUserInfo.emailCode": "Κωδικός επαλήθευσης email",
  "editUserInfo.save": "Αποθήκευση",

  // Σχετικά με τη σύνδεση τηλεφώνου
  "editUserInfo.phoneTips1": "Η σύνδεση του αριθμού τηλεφώνου ήταν επιτυχής",
  "editUserInfo.phoneTips2": "Αποστολή κωδικού επαλήθευσης SMS... Παρακαλώ περιμένετε...",
  "editUserInfo.phoneTips3": "Ο κωδικός επαλήθευσης SMS έχει σταλεί στον αριθμό xxxx, παρακαλώ ελέγξτε",
  "editUserInfo.phoneTips4": "Η αποστολή του κωδικού επαλήθευσης SMS απέτυχε!",
  "editUserInfo.phoneTips5": "Εισάγετε αριθμό τηλεφώνου",
  "editUserInfo.phoneTips6": "Μη έγκυρος μορφή αριθμού τηλεφώνου",
  "editUserInfo.phoneTips7": "Αποστολή κωδικού επαλήθευσης SMS",
  "editUserInfo.phoneTips8": "Κωδικός επαλήθευσης SMS",
  "editUserInfo.phoneTips9": "Το πεδίο κωδικού επαλήθευσης SMS δεν μπορεί να είναι κενό",
  "editUserInfo.phoneTips10": "Μη έγκυρος κωδικός επαλήθευσης SMS",
  "editUserInfo.phone": "Αριθμός τηλεφώνου",


  // Ρυθμίσεις ειδοποιήσεων
  "editUserInfo.noticeTips1": "Αποτυχία λήψης ρυθμίσεων ειδοποιήσεων!",
  "editUserInfo.noticeTips2": "Η αποθήκευση των ρυθμίσεων ειδοποιήσεων ήταν επιτυχής!",
  "editUserInfo.noticeTips3": "Ειδοποίηση χαμηλού επιπέδου μπαταρίας",
  "editUserInfo.noticeTips4": "Ειδοποίηση ολοκλήρωσης φόρτισης σταθμού φόρτισης",
  "editUserInfo.errorNotification": "Ειδοποίηση σφάλματος",
  "editUserInfo.updateNotification": "Ειδοποίηση ενημέρωσης",
  "editUserInfo.monthlyStatisticsNotification": "Ειδοποίηση μηνιακών στατιστικών",
  "editUserInfo.notificationMethod": "Μέθοδος λήψης",

  // Συμβουλές σχετικά με το όνομα χρήστη
  "editUserInfo.userNameTips1": "Η αποθήκευση του ονόματος χρήστη ήταν επιτυχής",
  "editUserInfo.userNameTips2": "Η αποθήκευση του ονόματος χρήστη απέτυχε",
  "editUserInfo.userNameTips3": "Εισάγετε όνομα χρήστη",
  "editUserInfo.userNameTips4": "Μη έγκυρη μορφή ονόματος χρήστη: Μπορεί να περιέχει μόνο αριθμούς, κάτω παύλα (_) και αγγλικά γράμματα",
  "editUserInfo.userNameTips5": "Εισάγετε όνομα χρήστη",
  "editUserInfo.userNameTips6": "Αποθήκευση... Παρακαλώ περιμένετε...",
  "editUserInfo.userName": "Όνομα χρήστη",

  // Συμβουλές επεξεργασίας εικόνας προφίλ
  "editUserInfo.avatorTips": "Κάντε κλικ για να αλλάξετε την εικόνα προφίλ",
  "editUserInfo.verifyCodeTips1": "Εισάγετε τον κωδικό επαλήθευσης που λάβατε:",
  "editUserInfo.verifyCodeTips2": "Για την ασφάλεια του λογαριασμού σας, κάντε κλικ στο κουμπί παρακάτω για να στείλετε κωδικό επαλήθευσης στον αρχικό αριθμό τηλεφώνου:",
  "editUserInfo.verifyCodeTips3": "Στείλε κώδικα",
  "editUserInfo.verifyCodeTips4": "Η επαλήθευση του αρχικού αριθμού τηλεφώνου ήταν επιτυχής, εισάγετε νέο αριθμό τηλεφώνου προς σύνδεση",
  "editUserInfo.verifyCodeTips5": "Για την ασφάλεια του λογαριασμού σας, κάντε κλικ στο κουμπί παρακάτω για να στείλετε κωδικό επαλήθευσης στο αρχικό email:",
  "editUserInfo.verifyCodeTips6": "Η επαλήθευση του αρχικού email ήταν επιτυχής, εισάγετε νέο email",
  "editUserInfo.verifyCodeTips7": "Παλαιός κωδικός πρόσβασης",
  "editUserInfo.verifyCodeTips8": "Πρώτα, συνδέστε το email!",
  "editUserInfo.verifyCodeTips9": "Ο κωδικός επαλήθευσης έχει σταλεί στο email, παρακαλώ ελέγξτε",
  "editUserInfo.verifyCodeTips10": ", θα μεταφερθείτε αυτόματα στη σελίδα εισόδου",

  // Σχετικά με τις ειδοποιήσεις
  "hems.notice.title": "Τίτλος ειδοποίησης", 
  "hems.notice.content": "Περιεχόμενο ειδοποίησης", 
  "hems.notice.operate": "Λειτουργία",
  "hems.notice.noRead": "Δεν έχει διαβαστεί",
  "hems.notice.read": "Έχει διαβαστεί",
  "hems.notice.warning": "Προειδοποίηση",
  "hems.notice.error": "Σφάλμα",
  "hems.notice.success": "Στατιστική υπολογισμού",
  "hems.notice.sys": "Πληροφορίες συστήματος",
  "hems.notice.operateSuccess": "Η λειτουργία ήταν επιτυχής",
  "hems.notice.operateTips": "Επιλέξτε στοιχείο για λειτουργία",

  // Αρχική σελίδα
  "hems.home.selfuseRate": "Ποσοστό προσωπικής χρήσης",
  "hems.home.percent": "Ποσοστό",
  "hems.home.todayData": "Σήμερα τα δεδομένα",
  "hems.home.todayPowerGeneration": "Παραγωγή ενέργειας σήμερα",
  "hems.home.salesIncome": "Έσοδα από πώληση ενέργειας",
  "hems.home.saved": "Έχετε εξοικονομήσει",
  "hems.home.reduce": "Μείωση ανθρακικού ίχνους",
  "hems.home.tips1": "Δεν υπάρχουν διαθέσιμα δεδομένα αυτή τη στιγμή, δεν έχετε συνδέσει ακόμη το xxxx",
  "hems.home.criticalLoad": "Κρίσιμη φορτίωση",
  "hems.home.keyVoltage": "Κρίσιμη τάση",
  "hems.home.householdLoad": "Φορτίωση οικίας",
  "hems.home.householdVoltage": "Τάση οικίας",
  "hems.home.generalLoad": "Γενική φορτίωση",
  "hems.home.generalVoltage": "Γενική τάση",
  "hems.home.batteryHealth": "Κατάσταση υγείας μπαταρίας",
  "hems.home.averageTemp": "Μέση θερμοκρασία",
  "hems.home.gridLoad": "Φορτίωση δικτύου ηλεκτρικής ενέργειας",
  "hems.home.toggeleDataSource": "Τα δεδομένα που εμφανίζονται έχουν αλλάξει ως εξής:",
  "hems.home.toggleTips": "Θέλετε να αλλάξετε?",
  "hems.home.modeSending": "Αποστολή εντολής λειτουργίας... Παρακαλώ περιμένετε...",
  "hems.home.modeSuccess": "Η αλλαγή λειτουργίας στάλθηκε επιτυχώς!",
  "hems.home.isOnline": "Είναι συνδεδεμένο;",
  "hems.home.useStatus": "Κατάσταση χρήσης",
  "hems.home.workModeText": "Τρέχουσα λειτουργία εργασίας:",
  "hems.home.toggleDataSourceText": "Τα δεδομένα που εμφανίζονται έχουν αλλάξει ως εξής:",
  "hems.ev.charge.status": "Κατάσταση φόρτισης",
  "hems.ev.charge.time": "Χρόνος φόρτισης",
  "hems.ev.charge.count": "Πραγματικός αριθμός φόρτισης (κατά το χρόνο)",
  "hems.ev.charge.status.empty": "Κενό",
  "hems.ev.charge.status.ing": "Συνδεδεμένο στη μπαταρία. Φορτίζει",
  "hems.ev.charge.status.null": "Συνδεδεμένο στη μπαταρία, αλλά δεν φορτίζει",
  "hems.ev.charge.status.error": "Σφάλμα",
  "hems.hour": "Ώρα",
  "hems.minue": "Λεπτό",
  "hems.ev.chagre.number": "Αριθμός σταθμού φόρτισης",

  // Οδηγός χρήσης
  "hems.userGuide.selfUse": "Προσωπική χρήση ανανεώσιμης ενέργειας",
  "hems.userGuide.selfUseTips": "Πρώτα, χρησιμοποιήστε ηλιακή ενέργεια, αν δεν είναι επαρκής, συμπληρώστε με δικτυο ηλεκτρικής ενέργειας",
  "hems.userGuide.economyMode": "Οικονομική λειτουργία",
  "hems.userGuide.economyModeTips": "Βελτιστοποίηση στρατηγικής χρήσης ενέργειας με βάση τις τιμές ηλεκτρικής ενέργειας",
  "hems.userGuide.emergencyMode": "Λειτουργία έκτακτης ανάγκης",
  "hems.userGuide.emergencyModeTips": "Προτεραιοποίηση υποστήριξης ενέργειας για κρίσιμες φορτίσεις",

  // Σελίδα γραφημάτων
  "hems.history.energyStatistics": "Στατιστικά ενέργειας",
  "hems.history.revenueStatistics": "Στατιστικά εσόδων",
  "hems.history.greenStatistics": "Μείωση εκπομπών χρωματικών αερίων",
  "hems.history.revenueTitle": "Συνολικά έσοδα από πώληση ενέργειας",
  "hems.history.savingsTitle": "Συνολική εξοικονόμηση",
  "hems.history.carbonTitle": "Συνολική μείωση άνθρακα",
  "hems.history.day": "Ημέρα",
  "hems.history.month": "Μήνας",
  "hems.history.year": "Έτος",
  "hems.history.beforeDay": "χθες",
  "hems.history.afterDay": "αύριο",
  "hems.history.beforeMonth": "προηγ. μ",
  "hems.history.afterMonth": "επόμ. μ",
  "hems.history.beforeYear": "προηγ. έτ",
  "hems.history.afterYear": "επόμ. έτ",
  "hems.history.totalUse": "Συνολική χρήση",
  "hems.history.fullScreen": "Πλήρης οθόνη",
  "hems.history.timeSelect": "Επιλέξτε ημέρα",
  "sync.tips1": "Η εντολή συγχρονισμού δεδομένων στάλθηκε επιτυχώς!",
  "sync.tips2": "Συγχρονισμός δεδομένων, απαιτείται χρόνος λόγω μεγάλου όγκου δεδομένων, ελέγξτε ξανά σε 50 λεπτά~",
  "sync.tips3": "Ο συγχρονισμός δεδομένων συσκευών μπορεί να καθυστερήσει, αν παρατηρήσετε ασυνέπειες στα δεδομένα, κάντε κλικ στο κουμπί παρακάτω:",
  "sync.tips4": "Συγχρονισμός δεδομένων",

  // Πληροφορίες σταθμού φόρτισης
  "charge.info": "Πληροφορίες σταθμού φόρτισης",
  "news.loading": "Φόρτωση...",
  "news.noMore": "Δεν υπάρχουν άλλα δεδομένα",
  "hems.pv.power": "Ποσότητα ηλιακής ενέργειας",

  // Συγκεκριμένες λειτουργίες UEH
  "ueh.sellPower": "Ποσότητα ενέργειας που πωλείται",
  
  // Μενού
  "menu.home": "Αρχική σελίδα",
  "menu.history": "Ιστορικά δεδομένα",
  "menu.device": "Συσκευές",
  "menu.settings": "Ρυθμίσεις",
  "menu.messageCenter": "Κέντρο μηνυμάτων",
  "menu.help": "Βοήθεια και υποστήριξη",
  "menu.mine": "Εγώ (προσωπικά)",


  // Οι ρυθμίσεις μου
  "mine.userSetting": "Ρυθμίσεις χρήστη",
  "mine.terminalSetting": "Βασικές ρυθμίσεις τερματικής συσκευής",
  "mine.uploadCloud": "Ανέβασμα δεδομένων στο σύννεφο",
  "mine.changeVersion": "Έλεγχος ενημερώσεων",
  "mine.language": "Αλλαγή γλώσσας",
  "mine.about": "Σχετικά με την εφαρμογή",
  "mine.feedback": "Ανατροφοδότηση",
  "mine.logout": "Αποσύνδεση",
  "mine.logoutAccount": "Διαγραφή λογαριασμού",

  // Σχετικά με τη διαγραφή λογαριασμού
  "mine.logoutAccountTips": "Διαγραφή λογαριασμού με όνομα []",
  "mine.logoutAccountTips1": "Διαγραφή λογαριασμού που συνδέεται με []",
  "mine.logoutAccountCare": "Σημειώσεις αιτήματος διαγραφής λογαριασμού:",
  "mine.logoutAccountCare1": "1. Ο λογαριασμός είναι σε πλήρως ασφαλές κατάσταση",
  "mine.logoutAccountCare1-1": "Ο λογαριασμός λειτουργεί κανονικά, δεν υπάρχει κίνδυνος κλοπής, παραβίασης κανόνων ή κλεισίματος",
  "mine.logoutAccountCare2": "2. Οι δικαιώματα πρόσβασης και οι συνδέσεις λογαριασμού διαγράφονται",
  "mine.logoutAccountCare2-1": "Όλα τα δικαιώματα πρόσβασης του λογαριασμού για τρίτες πλατφόρμες διαγράφονται",
  "mine.logoutAccountCare3": "3. Μετά τη διαγραφή, ο λογαριασμός δεν μπορεί να ανακτηθεί, τα δεδομένα χρήστη διαγράφονται",
  "mine.logoutAccountCare3-1": "Μετά τη διαγραφή, ο αριθμός τηλεφώνου, το email και σχετικά δεδομένα που συνδέονται διαγράφονται και δεν μπορούν να ανακτηθούν",
  "mine.confirmLogout": "Επιβεβαίωση διαγραφής",
  "mine.logoutSuccess": "Ο λογαριασμός διαγράφηκε επιτυχώς!",


  // Προβλήματα ανατροφοδότησης
  "mine.feedbackIssues": "Προβλήματα και ανατροφοδότηση",
  "mine.feedQuantity": "Ποσότητα",
  "mine.feedAmount": "Μέγιστο 9 εικόνες, μέγιστο μέγεθος κάθε εικόνας 1 MB",

  // Σχετικά με τις ρυθμίσεις ειδοποιήσεων
  "mine.notice.fail": "Αποτυχία λήψης ρυθμίσεων ειδοποιήσεων!",
  "mine.notice.saveSuccess": "Η αποθήκευση των ρυθμίσεων ειδοποιήσεων ήταν επιτυχής!",
  "mine.notice.saveFail": "Η αποθήκευση απέτυχε!",
  "mine.notice.title": "Ρυθμίσεις ειδοποιήσεων",
  "mine.notice.batteryLow": "Ειδοποίηση χαμηλού επιπέδου μπαταρίας",
  "mine.notice.chargingFinish": "Ειδοποίηση ολοκλήρωσης φόρτισης σταθμού φόρτισης",
  "mine.notice.error": "Ειδοποίηση σφάλματος",
  "mine.notice.update": "Ειδοποίηση ενημέρωσης",
  "mine.notice.monthly": "Ειδοποίηση μηνιακών στατιστικών",
  "mine.notice.receiveType": "Μέθοδος λήψης",

  // Καλώς ήρθατε στην ρύθμιση γλώσσας
  "mine.language.welcome": "Καλώς ήρθατε στο SusprSafe",
  "mine.language.desc1": "Επιλέξτε την έκδοση γλώσσας ανάλογα με την τοποθεσία του σπιτιού σας",
  "mine.language.desc2": "Μπορείτε να την αλλάξετε ανά πάσα στιγμή στις ρυθμίσεις της εφαρμογής",

  // Προσωπικές πληροφορίες
  "mine.userInfo.avatar": "Εικόνα προφίλ",
  "mine.userInfo.nickname": "Ψευδώνυμο",
  "mine.userInfo.password": "Κωδικός πρόσβασης",
  "mine.userInfo.changePassword": "Αλλαγή κωδικού πρόσβασης",
  "mine.userInfo.setPassword": "Ρύθμιση κωδικού πρόσβασης",
  "mine.userInfo.phoneNumber": "Αριθμός τηλεφώνου",
  "mine.userInfo.bindPhone": "Σύνδεση αριθμού τηλεφώνου",
  "mine.userInfo.bindEmail": "Σύνδεση email",
  "mine.loginExpired": "Η сеància εισόδου έχει λήξει, παρακαλώ συνδεθείτε ξανά",
  "mine.userInfo.title": "Πληροφορίες χρήστη",
  "mine.userInfo.bind": "Σύνδεση",
  "mine.userInfo.modify": "Τροποποίηση",
  "mine.userInfo.modifyNickname": "Τροποποίηση ψευδώνυμου",
  "mine.userInfo.userNickname": "Ψευδώνυμο χρήστη",
  "mine.userInfo.selectPic": "Επιλέξτε εικόνα για ανέβασμα",
  "mine.userInfo.saveSuccess": "Η αποθήκευση ήταν επιτυχής",
  "mine.userInfo.uploadFail": "Η ανέβασμα απέτυχε",
  "mine.userInfo.avatarSaveSuccess": "Η αποθήκευση της εικόνας προφίλ ήταν επιτυχής",
  "mine.userInfo.nameTips1": "Το πεδίο ψευδώνυμου δεν μπορεί να είναι κενό",
  "mine.userInfo.nameTips2": "Εισάγετε ψευδώνυμο",

  // Γενικές συμβουλές επιλογής
  "common.pleaseSelect": "Παρακαλώ επιλέξτε",
  "question.commonQuestions": "Συχνές ερωτήσεις",
  "account.toggleLanguage": "Αλλαγή γλώσσας",
  "account.localConnection": "Τοπική σύνδεση",
  "account.selectLanguage": "Παρακαλώ επιλέξτε γλώσσα",
  "account.sendEmailToast": "Ο κωδικός επαλήθευσης έχει σταλεί στο email xxx, παρακαλώ ελέγξτε",
  "account.emailError": "Μη έγκυρη μορφή email",
  "account.sendEmailFail": "Η αποστολή απέτυχε, παρακαλώ δοκιμάστε ξανά",
  
  "common.submitting": "Υποβολή... Παρακαλώ περιμένετε...",

  "device.page.noData": "Δεν υπάρχουν διαθέσιμα δεδομένα αυτή τη στιγμή, αυτή η σελίδα μπορεί να προβληθεί μόνο στην εφαρμογή"
,

  // OTA Upgrade
  "bmsFirmware.upgrade": "Upgrade",
  "bmsFirmware.upgrading": "Upgrading...",
  "bmsFirmware.uploadingFile": "Uploading firmware file...",
  "bmsFirmware.upgradingProgress": "Upgrading firmware... {progress}%",
  "bmsFirmware.upgradeSuccess": "Upgrade Successful",
  "bmsFirmware.upgradeSuccessSubtitle": "BMS firmware upgrade completed!",
  "bmsFirmware.upgradeFailed": "Upgrade Failed",
  "bmsFirmware.upgradeFailedFormError": "Please check if the form is filled correctly",
  "bmsFirmware.upgradeFailedNetworkError": "Network error, please retry",
  "bmsFirmware.invalidFileType": "Please select a valid firmware file (.bin, .hex, .fw, .firmware)",
  "bmsFirmware.selectFileWarning": "Please select a firmware file first",
  "bmsFirmware.statusUpgrading": "Upgrading",
  "bmsFirmware.statusCompleted": "Upgrade Completed",
  "bmsFirmware.statusFailed": "Upgrade Failed",
  "bmsFirmware.deviceUpgrading": "Upgrading firmware package, upgrade takes 30 ~ 50 minutes, real-time device data cannot be viewed during this period, please wait...",
  "bmsFirmware.upgradeStatusLabel": "Upgrade Status",
  "bmsFirmware.upgradeProgressLabel": "Upgrade Progress",
  "bmsFirmware.currentPackageLabel": "Current transmitted data package number",
  "bmsFirmware.totalPackagesLabel": "Total data packages",
  "bmsFirmware.upgradeFailedCheckDevice": "Please check device status and retry upgrade",

  // Setting Result Dialog Translations
  "settingResult.defaultTitle": "Setting Successful",
  "settingResult.defaultSubTitle": "Parameter settings saved",
  "settingResult.confirmButton": "OK"
};